import { DATA_API_SERVICE } from "@/appConfig";
import API from "@/api/api";
import PropertyType, { PropertyTypeAPIResponse } from "@/classes/propertyType";
import { sortBy } from "lodash";

async function findAll() {
  const response = await API.get<PropertyTypeAPIResponse[]>(`${DATA_API_SERVICE}/property/type`);
  const propertyTypes = response.data.map(propertyType => PropertyType.fromAPI(propertyType));
  return sortBy(propertyTypes, propertyType => propertyType.name);
}

async function create(propertyType: PropertyType) {
  return await API.post(`${DATA_API_SERVICE}/property/type`, propertyType);
}

async function update(propertyType: PropertyType) {
  return await API.put(`${DATA_API_SERVICE}/property/type/${propertyType.id}`, propertyType);
}

async function remove(propertyType: PropertyType) {
  return await API.delete(`${DATA_API_SERVICE}/property/type/${propertyType.id}`);
}

const APIPropertyType = {
  findAll,
  create,
  update,
  remove
};

export default APIPropertyType;
